import { ChevronRightIcon, IconProps } from "@jpmorganchase/uitk-icons";

export const BreadcrumbsSeparator = (props: IconProps) => (
  <ChevronRightIcon {...props} />
);
